/**
 * Icon system — single import site for every icon in the product.
 *
 * Rules (docs/design/ui-conventions.md):
 *  - NEVER use emoji or unicode glyphs as icons. Always a component from here.
 *  - Default size via className (`size-4` in buttons/rows, `size-5` nav,
 *    `size-8`+ only in empty states / feature tiles).
 *  - Directional icons that imply reading order (arrows in CTAs) get
 *    `icon-mirror` so RTL flips them; media controls (Play) never flip.
 *
 * Everything re-exports from lucide-react (tree-shaken) except the brand
 * credit mark, which is ours.
 */
export {
  ArrowRight,
  ArrowUpRight,
  AudioLines,
  BadgeCheck,
  Bot,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Clapperboard,
  Clock,
  Copy,
  Download,
  Eye,
  Film,
  Globe,
  Heart,
  Hourglass,
  Image as ImageIcon,
  Info,
  KeyRound,
  Layers,
  LayoutTemplate,
  LibraryBig,
  Loader,
  LogOut,
  Maximize2,
  Menu,
  Mic,
  Moon,
  Palette,
  Pause,
  Play,
  Plus,
  RefreshCw,
  Search,
  Settings,
  Share2,
  ShieldCheck,
  Sparkles,
  Sun,
  Terminal,
  Trash2,
  TriangleAlert,
  Upload,
  User,
  Wand2,
  X,
  Zap,
} from 'lucide-react';

/**
 * Brand credit mark — the platform's currency glyph (pairs with the logo's
 * four-point spark). Inherits `currentColor`; size it with `size-*`.
 */
export function CreditIcon({ className = 'size-4' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.75" />
      <path
        d="M12 6.75 C12 10 13.9 12 17.25 12 C13.9 12 12 14 12 17.25 C12 14 10.1 12 6.75 12 C10.1 12 12 10 12 6.75 Z"
        fill="currentColor"
      />
    </svg>
  );
}
